import React, { Component } from "react";
// Redux stuff
import { connect } from "react-redux";
import { settingsUpdate } from "../../redux/actions/providerActions";

// Component
import ButtonLoading from "../buttonLoading/ButtonLoading";

// Styles
import styles from "./topbar.module.css";

// Material Ui Components
import Button from "@material-ui/core/Button";

// Material Ui Icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import NotificationsIcon from "@material-ui/icons/Notifications";
import VisibilityIcon from "@material-ui/icons/Visibility";

function getFullScreenElement() {
    return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozDullscreenElement ||
        document.msFullscreenElement
    );
}

class Topbar extends Component {
    render() {
        const {
            name,
            buttonText,
            addNewProject,
            newProjectState,
            editButton,
            setEditButton,
            data,
            openEventCreatorModal,
        } = this.props;

        const pathname = window.location.pathname;

        const { loading } = this.props.provider;

        const settingsUpdate = (e) => {
            e.preventDefault();
            this.props.settingsUpdate({ ...data }, this.props.history);
            console.log(data);
        };

        return (
            <div className={styles.container}>
                <div className={styles.left}>
                    <button>
                        <ArrowBackIcon />
                    </button>
                    <span>{name}</span>
                </div>
                <div className={styles.right}>
                    <div className={styles.secondarButtonContainer}>
                        <button>
                            <NotificationsIcon style={{ fontSize: "20px" }} />
                        </button>
                        <button>
                            <VisibilityIcon
                                onClick={() => {
                                    if (getFullScreenElement()) {
                                        document.exitFullscreen();
                                    } else {
                                        document.documentElement
                                            .requestFullscreen()
                                            .catch((e) => {
                                                console.log(e);
                                            });
                                    }
                                }}
                                style={{ fontSize: "20px" }}
                            />
                        </button>
                    </div>

                    {pathname === "/dashboard/projectShowcase" ? (
                        <Button
                            fontSize="15px"
                            onClick={() => newProjectState()}
                            className={`${
                                addNewProject
                                    ? styles.cancleButton
                                    : styles.primaryButton
                            }`}
                            disabled={loading ? true : false}
                        >
                            {loading ? (
                                <ButtonLoading height={"25px"} width={"25px"} />
                            ) : addNewProject ? (
                                "cancel"
                            ) : (
                                buttonText
                            )}
                        </Button>
                    ) : pathname === "/dashboard/settings" ? (
                        <Button
                            fontSize="15px"
                            onClick={(e) => settingsUpdate(e)}
                            className={styles.primaryButton}
                            disabled={loading ? true : false}
                        >
                            {loading ? (
                                <ButtonLoading height={"25px"} width={"25px"} />
                            ) : (
                                buttonText
                            )}
                        </Button>
                    ) : pathname === "/dashboard/profile" ? (
                        <Button
                            fontSize="15px"
                            onClick={setEditButton}
                            className={styles.primaryButton}
                        >
                            {editButton ? "cancel" : buttonText}
                        </Button>
                    ) : pathname === "/dashboard/eventFeeds" ? (
                        <Button
                            fontSize="15px"
                            className={styles.primaryButton}
                            onClick={openEventCreatorModal}
                        >
                            {buttonText}
                        </Button>
                    ) : pathname === "/dashboard/search" ? null : (
                        <Button
                            fontSize="15px"
                            className={styles.primaryButton}
                        >
                            {buttonText}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, { settingsUpdate })(Topbar);
